<template>
  <a-range-picker
    style="width: 200px"
    :disabled-date="disabledDate"
    :format="dateFormat"
    @change="onChange"
    :value="getM"
    :allowClear="isClear"
  >
    <a-icon slot="suffixIcon" type="calendar" />
  </a-range-picker>
</template>
<script>
import moment from "moment";
export default {
  name: "StartendDate",
  props: {
    data: {
      type: String,
      default: () => [],
    },
    isClear: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    getM: function() {
      return this.data && this.data.length
        ? [
            moment(this.data[0], this.dateFormat),
            moment(this.data[1], this.dateFormat),
          ]
        : null;
    },
  },
  data() {
    return {
      dateFormat: "YYYY-MM-DD",
    };
  },
  mounted() {
    // console.log(this.startDate)
    // console.log(this.isClear)
  },
  methods: {
    moment,
    disabledDate(current) {
      if (!current) {
        return false;
      } else {
        // 大于当前日期不能选 current > moment()
        // 小于当前日期不能选 current < moment().subtract(1, "days")
        // 小于当前日期包括当天不能选 current && current < moment().endOf('day')
        // 只能选前7后7 current < moment().subtract(7, "days") || current > moment().add(7, "d")
        return current > moment();
      }
    },
    onChange(data, dateString) {
      if (data && data.length) {
        this.$emit("changeBack", [
          dateString[0] + " 00:00:00",
          dateString[1] + " 23:59:59",
        ]);
      } else {
        this.$emit("changeBack", []);
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
